import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  useCases: [],
  isSnackBarOpen: false,
  snackbarMessage: ''
}

const useCaseSlice = createSlice({
  name: 'useCase',
  initialState,
  reducers: {
    setUseCases: (state, action) => {
      state.useCases = action.payload
    },
    setIsSnackBarOpen: (state, action) => {
      state.isSnackBarOpen = action.payload
    },
    setSnackbarMessage: (state, action) => {
      state.snackbarMessage = action.payload
    }
  }
})

export const {setUseCases, setIsSnackBarOpen, setSnackbarMessage} = useCaseSlice.actions

export const selectUseCases = (state) => state.useCase?.useCases ?? []
export const selectIsSnackBarOpen = (state) => state.useCase?.isSnackBarOpen ?? false
export const selectSnackbarMessage = (state) => state.useCase?.snackbarMessage ?? ''

export default useCaseSlice.reducer
